import { render, staticRenderFns } from "./JCategorySelect.vue?vue&type=template&id=538becfa&"
import script from "./JCategorySelect.vue?vue&type=script&lang=js&"
export * from "./JCategorySelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('538becfa')) {
      api.createRecord('538becfa', component.options)
    } else {
      api.reload('538becfa', component.options)
    }
    module.hot.accept("./JCategorySelect.vue?vue&type=template&id=538becfa&", function () {
      api.rerender('538becfa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/jeecg/JCategorySelect.vue"
export default component.exports